module.exports = __webpack_public_path__ + "img/single-arrow.34febca0.svg";